var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHospital = function SvgHospital(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6253,
    cy: 4.95418,
    r: 3.94832,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.9163,
    y: 4.33398,
    width: 1.24782,
    height: 4.57533,
    rx: 0.623909,
    transform: "rotate(90 18.9163 4.33398)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2524,
    y: 7.24609,
    width: 1.24782,
    height: 4.57533,
    rx: 0.623909,
    transform: "rotate(-180 17.2524 7.24609)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9163,
    y: 4.33398,
    width: 1.24782,
    height: 4.57533,
    rx: 0.623909,
    transform: "rotate(90 18.9163 4.33398)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2524,
    y: 7.24609,
    width: 1.24782,
    height: 4.57533,
    rx: 0.623909,
    transform: "rotate(-180 17.2524 7.24609)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.93896,
    y: 11.0098,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8086,
    y: 11.0098,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6782,
    y: 11.0098,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5479,
    y: 11.0098,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.93896,
    y: 15.8789,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8086,
    y: 15.8789,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6782,
    y: 15.8789,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5479,
    y: 15.8789,
    width: 2.76383,
    height: 2.76383,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8.00477,
    y: 20.8139,
    width: 2.63221,
    height: 2.63221,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8744,
    y: 20.8139,
    width: 2.63221,
    height: 2.63221,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 17.744,
    y: 20.8139,
    width: 2.63221,
    height: 2.63221,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6137,
    y: 20.8139,
    width: 2.63221,
    height: 2.63221,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8.00477,
    y: 25.683,
    width: 2.63221,
    height: 2.63221,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8744,
    y: 25.683,
    width: 7.50181,
    height: 7.50181,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6137,
    y: 25.683,
    width: 2.63221,
    height: 2.63221,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.131611
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58295,
    y: 5.41571,
    width: 24.0848,
    height: 29.086,
    stroke: "black",
    strokeWidth: 2.5006
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHospital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hospital.d5e7e7d010b59ef0b22667f20faa485b.svg";